<template>
    <div class="sec-banner">
        <div v-if="isCN" class="bannerCN" @click="handleClick">
            <!-- <CommonComponentsButtonLine
                light
                transparent
                borderless
                :button-text="t('global_home_swipper_banner')"
                class="callBack"
                @click="callBack()"
            /> -->
            <div class="title">
                <img :src="SecBannerTitle" alt="" />
            </div>
            <img :src="SecBanner" alt="bannerUrl" class="bg" />
        </div>
        <!-- <div v-else class="bannerEN">
            <div class="bannerEN-body">
                <img class="title" :src="SecBannerENTitle" alt="" />
                <div class="subtitle">The Grand Opening of Styleverse Paris the 5th world wide Styleverse</div>
                <div class="follow">Styleverse Paris - 30 Rue Jacob 75006 Paris</div>

                <CommonComponentsButtonLine
                    :light="isCN || !isMobile"
                    :transparent="isCN || !isMobile"
                    borderless
                    :button-text="t('global_home_swipper_banner')"
                    class="callBack"
                    @click="callBack()"
                />
            </div>
            <img class="bg" :src="imgUrl" alt="bannerUrl" />
        </div> -->
    </div>
</template>

<script lang="ts" setup>
    import SecBanner from '@assets/imgs/Home/Solutions/SecBanner.png';
    import SecBannerMobile from '@assets/imgs/Home/Solutions/SecBannerMobile.png';
    import SecBannerTitle from '@assets/imgs/Home/Solutions/SecBannerTitle.png';

    import SecBannerEN from '@assets/imgs/Home/Solutions/SecBannerEN.png';
    import SecBannerMobileEN from '@assets/imgs/Home/Solutions/SecBannerMobileEN.png';
    import SecBannerENTitle from '@assets/imgs/Home/Solutions/SecBannerENTitle.png';

    import i18n from '@/locales';
    import { matchMobile } from '~~/composables/useMatchRules.ts';
    import { ref, reactive, onMounted, onBeforeMount, computed } from 'vue';
    import { ifCNLocale } from '~~/composables/useLocale.ts';
    const isCN = ifCNLocale();
    const isMobile = ref(false);
    const { t } = i18n.global;
    const imgUrl = computed(() => {
        if (isCN) {
            return isMobile.value ? SecBannerMobile : SecBanner;
        } else {
            return isMobile.value ? SecBannerMobileEN : SecBannerEN;
        }
    });

    const handleClick = () => {
        window.open('https://zhresource.linctex.com/chinafashionforum');
    };

    const callBack = () => {
        window.open(
            isCN
                ? 'https://zhresource.linctex.com/%E5%9B%BD%E5%86%85%E6%B4%BB%E5%8A%A8-24%E5%B9%B43%E6%9C%88chic-intertextile%E5%B1%95-1'
                : 'https://share-eu1.hsforms.com/1rWSD2MPkTRWLAWAqeZ63Ywf6b0c',
        );
    };
    onMounted(() => {
        isMobile.value = matchMobile();
    });
</script>

<style lang="less" scoped>
    .sec-banner {
        height: 100vh;
        overflow: hidden;
        position: relative;

        .bannerCN {
            .bg {
                width: 100%;
            }
            .title {
                align-content: center;
                position: absolute;
                top: 50%;
                left: .convert(114px) [ @vw];
                transform: translateY(-50%);
                img {
                    width: .convert(800px) [ @vw];
                }
            }
            .callBack {
                position: absolute;
                bottom: 10%;
                left: 50%;
                transform: translateX(-50%);
                font-size: .convert(24px) [ @vw];
                text-shadow: 0px 0px 60px #3a3a3a;
                @media (max-width: @screen-mobile-width) {
                    bottom: .convert(60px) [ @vw-mobile];
                    font-size: .convert(14px;) [ @vw-mobile];
                }
            }
        }

        // .bannerEN {
        //     display: flex;
        //     justify-content: center;

        //     .bg {
        //         width: 100%;
        //         position: absolute;
        //         z-index: -1;
        //         top: 0;
        //     }

        //     &-body {
        //         height: 100vh;
        //         display: flex;
        //         flex-direction: column;
        //         justify-content: center;
        //         align-content: center;
        //         margin-left: .convert(536px) [ @vw];
        //         .title {
        //             width: .convert(360px) [ @vw];
        //             margin-bottom: .convert(30px) [ @vw];
        //             @media (max-width: @screen-mobile-width) {
        //                 display: none;
        //             }
        //         }
        //         .subtitle {
        //             width: .convert(710px) [ @vw];
        //             color: #fff;
        //             font-family: Montserrat;
        //             font-size: .convert(36px) [ @vw];
        //             font-style: normal;
        //             font-weight: 500;
        //             line-height: normal;
        //             margin-bottom: .convert(30px) [ @vw];
        //             @media (max-width: @screen-mobile-width) {
        //                 display: none;
        //             }
        //         }
        //         .follow {
        //             width: .convert(518px) [ @vw];
        //             color: #c8c8c8;
        //             font-family: Poppins;
        //             font-size: .convert(24px) [ @vw];
        //             font-style: normal;
        //             font-weight: 400;
        //             line-height: normal;
        //             margin-bottom: .convert(125px) [ @vw];
        //             @media (max-width: @screen-mobile-width) {
        //                 display: none;
        //             }
        //         }
        //         .callBack {
        //             margin-left: .convert(190px) [ @vw];
        //             font-size: .convert(24px) [ @vw];
        //             @media (max-width: @screen-mobile-width) {
        //                 margin-left: .convert(0px) [ @vw];
        //                 position: absolute;
        //                 top: 60%;
        //                 left: 50%;
        //                 transform: translateX(-50%);
        //                 font-size: .convert(14px) [ @vw-mobile];
        //                 width: .convert(121px) [ @vw-mobile];
        //                 height: .convert(40px) [ @vw-mobile];
        //             }
        //         }
        //     }
        // }
    }
</style>
